<div
  class="fb-fs-editor"
  [class.fb-fs-editor--dark]="isDark"
  (keydown)="onKeyDown($event)">
  <div class="fb-fs-editor__header">
    <div class="fb-fs-editor__title">
      <i class="fa-solid fa-code"></i>
      <span>JSON Form Editor</span>
    </div>
    <div class="fb-fs-editor__actions">
      <button
        class="btn btn-sm btn-outline-secondary"
        (click)="toggleTheme()"
        [title]="isDark ? 'Switch to light mode' : 'Switch to dark mode'">
        <i
          class="fa-solid"
          [class.fa-sun]="isDark"
          [class.fa-moon]="!isDark"></i>
        {{ isDark ? 'Light' : 'Dark' }}
      </button>
      <button
        class="btn btn-sm btn-outline-secondary"
        (click)="onFormat()"
        title="Format JSON">
        <i class="fa-solid fa-align-left"></i> Format
      </button>
      <button
        class="btn btn-sm btn-primary"
        (click)="onSave()"
        [disabled]="hasError"
        title="Save (Ctrl+S)">
        <i class="fa-solid fa-check"></i> Save & Close
      </button>
      <button
        class="btn btn-sm btn-outline-secondary"
        (click)="onClose()"
        title="Close (Esc)">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
  </div>
  <div class="fb-fs-editor__error" *ngIf="hasError">
    <i class="fa-solid fa-triangle-exclamation"></i>
    {{ errorMessage }}
  </div>
  <ngx-monaco-editor
    class="fb-fs-editor__monaco"
    [options]="editorOptions"
    [(ngModel)]="code"
    (ngModelChange)="onCodeChange($event)">
  </ngx-monaco-editor>
</div>
